mutation RestoreTagTypes($ids: [ID!]!) {
  restoreTagTypes(ids: $ids) {
    id
  }
}

